import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { setupAxios } from './utils/axios';
import { store } from './app/store';
import { Provider } from 'react-redux';
import { ThemeProvider } from './utils/theme-context';
import { installChunkLoadRecovery } from './utils/chunkLoadRecovery';


installChunkLoadRecovery();
setupAxios();
const root = ReactDOM.createRoot(document.getElementById('root') as Element);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Provider store={store}>
                <ThemeProvider>
                    <App />
                </ThemeProvider>
            </Provider>
        </BrowserRouter>
    </React.StrictMode>,
);
